/**
 * Bootstraps listeners once at app startup (called from AuthInitializer).
 */

import { initAuthBroadcastListeners } from '@/lib/session/auth-broadcast'
import { initOfflineBroadcast } from '@/lib/session/offline-queue'
import { initActivitySilenceRefresh } from '@/lib/session/activity-listener'

let started = false

export function initSessionOrchestration(): void {
  if (started) return
  started = true
  initAuthBroadcastListeners()
  initOfflineBroadcast()
  initActivitySilenceRefresh()
}
